"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const lib_1 = require("@brandfree-front/lib");
const mobx_1 = require("mobx");
const GaButton_1 = __importDefault(require("../../util/GaButton"));
const GDPRChoice_1 = __importDefault(require("./GDPRChoice"));
const ContactInfoForm_1 = __importDefault(require("../contactinfo/ContactInfoForm"));
const StoresUtil_1 = require("../../util/StoresUtil");
const crm_components_1 = require("crm-components");
const PartyPrivacyProfileStore_1 = require("../../stores/PartyPrivacyProfileStore");
let GDPRChoicesB2C = class GDPRChoicesB2C extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "consentStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contactInfoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ssoStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "locationStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "partyPrivacyProfileStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signingInProgress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "checkAllConsents", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const allowed = !this.consentStore.allB2CConsentsTrue;
                this.consentStore.allowConsent(this.consentStore.trafficDataAnalysis, allowed);
                this.consentStore.allowConsent(this.consentStore.locationDataAnalysis, allowed);
                this.consentStore.allowConsent(this.consentStore.directMarketing, allowed);
            }
        });
        Object.defineProperty(this, "checkAllAgreements", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                var _a;
                const allowed = !this.partyPrivacyProfileStore.allAgreementsTrue;
                (_a = this.partyPrivacyProfileStore.agreements) === null || _a === void 0 ? void 0 : _a.forEach((agreement) => (agreement.checkboxValue = allowed));
            }
        });
        Object.defineProperty(this, "onConfirm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.doConfirm().then(() => (0, mobx_1.runInAction)(() => (this.signingInProgress = false)));
            }
        });
        Object.defineProperty(this, "doConfirm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                this.signingInProgress = true;
                if (this.partyPrivacyProfileStore.hasChangedAgreements) {
                    await this.partyPrivacyProfileStore.signClickAcceptProfile().then(() => (0, crm_components_1.navigate)('/success'));
                }
                this.signingInProgress = false;
            }
        });
        Object.defineProperty(this, "onCancel", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                this.props.onCancel();
                this.locationStore.redirectUrl ? window.location.replace(this.locationStore.redirectUrl) : this.ssoStore.doLogout();
            }
        });
        (0, mobx_1.makeObservable)(this);
    }
    render() {
        const { translate } = this.translateStore;
        const { allAgreementsTrue, isProfileCreationLoading, isProfileGetLoading } = this.partyPrivacyProfileStore;
        if (isProfileGetLoading) {
            return react_1.default.createElement(lib_1.Spinner, null);
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.contactInfoStore.isCustomerConsentReady ? null : react_1.default.createElement(ContactInfoForm_1.default, null),
            react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
                react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10', 'lg-8'] },
                    react_1.default.createElement(lib_1.Text, { className: "text-center" },
                        react_1.default.createElement(lib_1.Heading, { className: "text-primary h2" }, translate('gdpr.title')),
                        react_1.default.createElement(lib_1.Grid, { align: ['center-xs'] },
                            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10'] },
                                react_1.default.createElement("p", null, translate('gdpr.info.b2c')))),
                        react_1.default.createElement(GaButton_1.default, { id: "gdpr-choices-check-all", className: "text__margin-double", text: translate(allAgreementsTrue ? 'gdpr.choice.deSelectAll' : 'gdpr.choice.selectAll'), onClick: () => {
                                this.checkAllConsents();
                                this.checkAllAgreements();
                            } }),
                        react_1.default.createElement(lib_1.Grid, { align: ['center-xs'], className: "text__margin-none" },
                            react_1.default.createElement(lib_1.GridColumn, { width: ['xs-12', 'md-10'] },
                                react_1.default.createElement(lib_1.Card, { background: "transparent" },
                                    react_1.default.createElement(lib_1.CardContent, { className: "text-left" },
                                        react_1.default.createElement(lib_1.Separator, { spacing: "small", weight: "thin", color: "medium", fullWidth: true }),
                                        react_1.default.createElement(GDPRChoice_1.default, { id: "gdpr-b2c-traffic", text: translate('gdpr.choice.b2c.traffic.main'), description: translate('gdpr.choice.b2c.traffic.description'), checked: this.partyPrivacyProfileStore.getCheckBoxValue(PartyPrivacyProfileStore_1.AgreementType.TRAFFIC_DATA_ANALYSIS), onChange: (value) => {
                                                this.consentStore.allowConsent(this.consentStore.trafficDataAnalysis, value);
                                                this.partyPrivacyProfileStore.setAgreementValue(PartyPrivacyProfileStore_1.AgreementType.TRAFFIC_DATA_ANALYSIS, value);
                                            }, onDetailsClick: () => (0, crm_components_1.navigate)('/personaalsed-pakkumised-info') }),
                                        react_1.default.createElement(lib_1.Separator, { spacing: "small", weight: "thin", fullWidth: true }),
                                        react_1.default.createElement(GDPRChoice_1.default, { id: "gdpr-b2c-location", text: translate('gdpr.choice.b2c.location.main'), description: translate('gdpr.choice.b2c.location.description'), checked: this.partyPrivacyProfileStore.getCheckBoxValue(PartyPrivacyProfileStore_1.AgreementType.LOCATION_DATA_ANALYSIS), onChange: (value) => {
                                                this.consentStore.allowConsent(this.consentStore.locationDataAnalysis, value);
                                                this.partyPrivacyProfileStore.setAgreementValue(PartyPrivacyProfileStore_1.AgreementType.LOCATION_DATA_ANALYSIS, value);
                                            }, onDetailsClick: () => (0, crm_components_1.navigate)('/asukoha-andmete-info') }),
                                        react_1.default.createElement(lib_1.Separator, { spacing: "small", weight: "thin", fullWidth: true }),
                                        react_1.default.createElement(GDPRChoice_1.default, { id: "gdpr-b2c-marketing", text: translate('gdpr.choice.b2c.marketing.main'), description: translate('gdpr.choice.b2c.marketing.description'), checked: this.partyPrivacyProfileStore.getCheckBoxValue(PartyPrivacyProfileStore_1.AgreementType.DIRECT_MARKETING), onChange: (value) => {
                                                this.consentStore.allowConsent(this.consentStore.directMarketing, value);
                                                this.partyPrivacyProfileStore.setAgreementValue(PartyPrivacyProfileStore_1.AgreementType.DIRECT_MARKETING, value);
                                            }, onDetailsClick: () => (0, crm_components_1.navigate)('/turunduspakkumised-info') }),
                                        react_1.default.createElement(lib_1.Separator, { spacing: "small", weight: "thin", color: "medium", fullWidth: true }))),
                                react_1.default.createElement(lib_1.Grid, { align: ['center-xs', 'middle-xs'] },
                                    react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] },
                                        react_1.default.createElement(GaButton_1.default, { id: "gdpr-choices-b2c-cancel", text: translate('gdpr.cancelButton'), link: true, onClick: this.onCancel })),
                                    react_1.default.createElement(lib_1.GridColumn, { width: ['xs'] }, isProfileCreationLoading || this.signingInProgress || this.consentStore.confirmLoading ? (react_1.default.createElement(lib_1.Spinner, null)) : (react_1.default.createElement(GaButton_1.default, { id: `gdpr-choices-b2c-confirm_${this.partyPrivacyProfileStore.agreementChoices}`, text: translate('gdpr.choices.confirm'), onClick: async () => {
                                            await this.onConfirm();
                                        }, disabled: this.ssoStore.isDealer, isLoading: isProfileCreationLoading })))))))))));
    }
};
__decorate([
    mobx_1.observable
], GDPRChoicesB2C.prototype, "signingInProgress", void 0);
__decorate([
    mobx_1.action
], GDPRChoicesB2C.prototype, "checkAllConsents", void 0);
__decorate([
    mobx_1.action
], GDPRChoicesB2C.prototype, "checkAllAgreements", void 0);
__decorate([
    mobx_1.action
], GDPRChoicesB2C.prototype, "onConfirm", void 0);
__decorate([
    mobx_1.action
], GDPRChoicesB2C.prototype, "doConfirm", void 0);
GDPRChoicesB2C = __decorate([
    StoresUtil_1.injectStores,
    mobx_react_1.observer
], GDPRChoicesB2C);
exports.default = GDPRChoicesB2C;
